import { render, staticRenderFns } from "./Sprite.vue?vue&type=template&id=84d67b56&scoped=true&"
import script from "./Sprite.vue?vue&type=script&lang=js&"
export * from "./Sprite.vue?vue&type=script&lang=js&"
import style0 from "./Sprite.vue?vue&type=style&index=0&id=84d67b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d67b56",
  null
  
)

export default component.exports